module.exports = __webpack_public_path__ + "img/Families.b84a5875.svg";